// extracted by mini-css-extract-plugin
export var heroImage = "_ds-1";
export var modal = "_ds-0";